import { useRemoteQuery } from "../useRemote/useRemoteQuery";
import { RemoteApiError } from "../useRemote/types";
import { LocationInventory } from "../../../features/FloorManager/typings/location-inventory";

export type UseRemoteFetchCompanyLocationsFilter = {
  isFinanceRequest: boolean;
  noMobileWorking: boolean;
  isBookingSettings?: boolean;
  enabled?: boolean;
};

export function useRemoteFetchCompanyLocations(filter: UseRemoteFetchCompanyLocationsFilter) {
  const { noMobileWorking, isFinanceRequest, isBookingSettings, enabled = true } = filter;

  return useRemoteQuery<LocationInventory[], RemoteApiError>({
    queryKey: ["companyLocations", noMobileWorking, isFinanceRequest, isBookingSettings],
    url: "/location/companies-schedule",
    params: {
      noMobileWorking,
      isFinanceRequest,
      isBookingSettings
    },
    enabled:
      enabled &&
      noMobileWorking !== undefined &&
      isFinanceRequest !== undefined &&
      isBookingSettings !== undefined
  });
}
